<template>
  <div class="square">
    <span class="square__title">
      <strong>{{ title }}</strong>
    </span>
    <slot name="squareInfo"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "No title"
    }
  }
};
</script>
<style lang="scss">
.square {
  margin-top: 10px;
  width: calc(50% - 10px);
  border: 1px solid #dddddd;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background-color: white;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }

  &__title {
    margin-bottom: 20px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      //width: 75px;
      width: 100%;
      height: 1px;
      background-color: #dddddd;
      bottom: -10px;
      left: 0;
    }
  }
}
</style>
